// extracted by mini-css-extract-plugin
module.exports = {"avatarPhoto":"TrailAvatar_avatarPhoto___qeND"};